<template>
	<ButtonIcon
		v-if="canOpenHelp"
		notext
		color="primary"
		icon="fa-solid fa-circle-question"
		icon-size="small"
		:data-test="dataTest"
		:loading="loading"
		:tooltip="{ text: label, bottom: true }"
		@click="openHelp(path)"
	/>
</template>

<script setup lang="ts">
import ButtonIcon from 'components/templates/Base/ButtonIcon.vue'
import { useHelpPortal } from '@/composables/useHelpPortal'

// AAR-1805. Die Beschriftung ist absichtlich deutsch fest verdrahtet, wie der
// Offline-Hinweis in der Toolbar daneben: die Hilfe selbst gibt es nur auf
// Deutsch, ein englischer Tooltip würde also auf deutsche Inhalte zeigen.
//
// Der Riegel sitzt hier im Button und nicht in der Toolbar: die Toolbar
// entscheidet nur über den Breakpoint (ab sm), die Rolle gehört zur Hilfe.
const { openHelp, loading, canOpenHelp } = useHelpPortal()

// Ohne `path` bleibt es der Einstieg aus der Toolbar (Startseite der Hilfe).
// Mit `path` wird derselbe Button zum Sprung auf einen bestimmten Artikel —
// der Pfad ist der Seitenpfad in der Aaremo-Hilfe, z. B.
// "/aufgaben/handwerkerauftraege".
// `dataTest` bleibt auf dem Toolbar-Wert, damit die bestehenden Cypress-Specs
// weiterlaufen. Jeder weitere Einsatz im Seiteninhalt setzt einen eigenen —
// zwei gleiche data-test auf einer Seite treffen sonst beide.
withDefaults(
	defineProps<{
		path?: string
		label?: string
		dataTest?: string
	}>(),
	{
		path: undefined,
		label: 'Hilfe öffnen',
		dataTest: 'appBar__help-btn',
	}
)
</script>
